// The rates API needs each side's state to detect inter-state routes (e.g. Fez).
// Spread into senderDetails/receiverDetails; omits the field when the state is unknown.
export const withRateState = state => {
  const trimmedState = typeof state === 'string' ? state.trim() : '';

  return trimmedState ? { state: trimmedState } : {};
};
